import PlusIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Button, Divider, IconButton, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { CirclePicker } from "react-color";

const presetColors = [
  "#f44336",
  "#e91e63",
  "#9c27b0",
  "#673ab7",
  "#3f51b5",
  "#2196f3",
  "#03a9f4",
  "#00bcd4",
  "#009688",
  "#4caf50",
  "#8bc34a",
  "#cddc39",
  "#ffeb3b",
  "#ffc107",
  "#ff9800",
  "#ff5722",
  "#795548",
  "#607d8b",
];

const additionalColors = [
  // Additional colors
  "#F2C200",
  "#FFC303",
  "#EB870F",
  "#EE9241",
  "#FA6D30",
  "#F4CB95",
  "#E0AF94",
  "#F3B3C4",
  "#DB7BB7",
  "#EB366C",
  "#AE263D",
  "#D70F14",
  "#6D221C",
  "#556D28",
  "#72C201",
  "#245438",
  "#198180",
  "#4ECAD6",
  "#27BAC2",
  "#CFE8EA",
  "#91C098",
  "#627D7A",
  "#445061",
  "#0E273C",
  "#6B3EB5",
  "#2B3A8F",
  "#8CA9CD",
];

const grayscaleColors = [
  // Grayscale colors
  "#000000",
  "#333333",
  "#666666",
  "#999999",
  "#CCCCCC",
];

function ColorPicker(props) {
  const [displayColorPicker, setDisplayColorPicker] = useState(-1);

  const handleClick = (idx) => {
    setDisplayColorPicker(idx);
  };

  const handleClose = () => {
    setDisplayColorPicker(-1);
  };

  const handleChange = (val, idx) => {
    const newColors = [...props.colors];
    newColors[idx] = val.hex;
    props.onChange(newColors);
  };

  const handleNewColor = () => {
    props.onChange([...props.colors, "#000000"]);
    setDisplayColorPicker(props.colors.length);
  };

  const handleRemoveColor = (idx) => {
    const newColors = props.colors.filter((_, index) => index !== idx);
    props.onChange(newColors);
  };

  const styles = {
    swatch: {
      padding: "2px 5px",
      background: "#fff",
      borderRadius: "4px",
      border: "1px solid #ccc",
      cursor: "pointer",
      justifyContent: "center",
      alignItems: "center",
    },
    popover: {
      position: "absolute",
      zIndex: "2",
      top: "40px",
      left: "0px",
      background: "#fff",
      padding: "8px 0 8px 8px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
      maxWidth: "300px",
    },
    cover: {
      position: "fixed",
      top: "0px",
      right: "0px",
      bottom: "0px",
      left: "0px",
    },
  };

  return (
    <Stack direction="row" spacing={1} sx={{ position: "relative" }}>
      {props.colors.map((color, index) => (
        <Stack key={index} direction="row" sx={styles.swatch}>
          <Box
            sx={{
              width: "36px",
              height: "20px",
              borderRadius: "2px",
              backgroundColor: color,
            }}
            onClick={() => handleClick(index)}
          />
          <IconButton size="small" onClick={() => handleRemoveColor(index)}>
            <RemoveIcon fontSize="inherit" />
          </IconButton>
          {displayColorPicker === index ? (
            <>
              <Box sx={styles.cover} onClick={handleClose} />
              <Box sx={styles.popover}>
                <Typography variant="caption2" color="#aaa" mb={1} display="block">
                  Tattoo Specific
                </Typography>
                <CirclePicker
                  disableAlpha
                  circleSize={24}
                  circleSpacing={8}
                  width="100%"
                  color={props.colors[displayColorPicker]}
                  colors={additionalColors}
                  onChange={(val) => {
                    handleChange(val, displayColorPicker);
                    setDisplayColorPicker(-1);
                  }}
                />
                <Divider sx={{ my: 1, mr: 1 }} />
                <Typography variant="caption2" color="#aaa" mb={1} display="block">
                  Primary
                </Typography>
                <CirclePicker
                  disableAlpha
                  circleSize={24}
                  circleSpacing={8}
                  width="100%"
                  color={props.colors[displayColorPicker]}
                  colors={presetColors}
                  onChange={(val) => {
                    handleChange(val, displayColorPicker);
                    setDisplayColorPicker(-1);
                  }}
                />
                <Divider sx={{ my: 1, mr: 1 }} />
                <Typography variant="caption2" color="#aaa" mb={1} display="block">
                  Grayscale
                </Typography>
                <CirclePicker
                  disableAlpha
                  circleSize={24}
                  circleSpacing={8}
                  width="100%"
                  color={props.colors[displayColorPicker]}
                  colors={grayscaleColors}
                  onChange={(val) => {
                    handleChange(val, displayColorPicker);
                    setDisplayColorPicker(-1);
                  }}
                />
              </Box>
            </>
          ) : null}
        </Stack>
      ))}
      {props.colors.length < 4 && (
        <Stack>
          <Button
            variant="outlined"
            onClick={handleNewColor}
            style={{
              width: "36px",
              height: "34px",
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2px 5px",
              background: "#fff",
              borderRadius: "4px",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
            disableRipple
            disabled={props.disabled ?? false}
          >
            <PlusIcon />
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

export default ColorPicker;
